// Module
var code = "Voir mes amis inscrits";
// Exports
module.exports = code;